import { render, staticRenderFns } from "./shutdownOrder.vue?vue&type=template&id=36597f09&scoped=true&"
import script from "./shutdownOrder.vue?vue&type=script&lang=js&"
export * from "./shutdownOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36597f09",
  null
  
)

export default component.exports